<template>
  <div class="modal-box">
    <div class="modal-title">
      <h3>Nieuw Project</h3>
      <div class="flex-divider"></div>
      <base-button type="secondary" @click="closeModal">
        <base-icon iconRef="close" />
      </base-button>
    </div>
    <div class="modal-content">
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Basisgegevens</h4>
        </div>
        <div class="input-container">
          <label for="projectName" class="label required">Projectnaam</label>
          <base-input
            type="text"
            id="projectName"
            name="projectName"
            placeholder="Projectnaam"
            v-model="newProjectData.projectName"
            data-vv-as="Projectnaam"
            v-validate="'required'"
          />
          <base-input-warning :error="errors.first('projectName')" />
        </div>
        <div class="input-container">
          <label for class="label">Beschrijving</label>
          <textarea
            class="input"
            rows="4"
            placeholder="Beschrijving"
            v-model="newProjectData.description"
          ></textarea>
        </div>
      </div>
      <div class="modal-content-section">
        <div class="input-header">
          <h4>Adres</h4>
        </div>
        <div class="input-row">
          <div class="input-container big">
            <label class="label" for>Straat</label>
            <base-input
              type="text"
              placeholder="Straatnaam"
              v-model="newProjectData.address.street"
            />
          </div>
          <div class="input-container small">
            <label class="label" for>Huisnummer</label>
            <base-input type="text" placeholder="0" v-model="newProjectData.address.houseNumber" />
          </div>
        </div>
        <div class="input-container">
          <label class="label" for>Stad</label>
          <base-input type="text" placeholder="Stad" v-model="newProjectData.address.city" />
        </div>
        <div class="input-container">
          <label class="label" for>Postcode</label>
          <base-input type="text" placeholder="1234AB" v-model="newProjectData.address.postCode" />
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-divider"></div>
      <base-button @click="closeModal" type="secondary">Annuleren</base-button>
      <base-button @click="createProject" :loading="creatingProject" :disabled="creatingProject">
        <base-icon iconRef="checkmark" position="left" />Aanmaken
      </base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "project-create-modal",
  data: function () {
    return {
      creatingProject: false,
      newProjectData: {
        projectName: "",
        description: "",
        address: {
          street: "",
          houseNumber: "",
          city: "",
          postCode: "",
        },
      },
    };
  },
  methods: {
    createProject: function () {
      this.$validator.validate().then((result) => {
        if (result) {
          this.creatingProject = true;
          const newProject = this.$createNewProject(this.newProjectData);
          newProject.belongsTo = this.$route.params.clientId;
          this.$firestore
            .collection("projects")
            .add(newProject)
            .then((doc) => {
              this.creatingProject = false;
              this.closeModal();
              this.$router.push("/project/" + doc.id);
            });
        }
      });
    },
    closeModal: function () {
      this.$store.commit("setModalShown", {
        dataType: "project",
        modalType: "create",
        shown: false,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modal-components/project-create-modal.vue